import { render, staticRenderFns } from "./mobileContent1.vue?vue&type=template&id=2b824e99&scoped=true"
import script from "./mobileContent1.vue?vue&type=script&lang=js"
export * from "./mobileContent1.vue?vue&type=script&lang=js"
import style0 from "./mobileContent1.vue?vue&type=style&index=0&id=2b824e99&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b824e99",
  null
  
)

export default component.exports